export default class Utils {
  static getQueryParameterByName(name: string, url?: string) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  static getPathName() {
    return window.location.pathname;
  }
}


// WEBPACK FOOTER //
// ./static-content/public/javascripts/utils.ts